import { CameraModel } from 'src/app/engine/models/camera.model';
import { CameraMotionModel } from '../../models/camera-motion.model';
import { EngineCameraStateModel } from './engine.camera.state.model';
import { Patch } from 'src/vendor/immer-6.0.9/compat/pre-3.7/dist/immer';

export class ClearCamera {
  static readonly type = '[Engine Camera] Clear Camera';
  constructor(public id: string) { }
}

export class StoreCamera {
  static readonly type = '[Engine Camera] Store Camera';
  constructor(public id: string, public camera?: CameraModel) { }
}

export class SetCamera {
  static readonly type = '[Engine Camera] Set Camera';
  constructor(public camera: CameraModel, public animate: boolean = true, public animationDuration?: number) {}
}

export class SetCameraSuccess {
  static readonly type = '[Engine Camera] Set Camera Success';
  constructor() {}
}

export class MoveCamera {
  static readonly type = '[Engine Camera] Move Camera';
  constructor(public cameraMotion: CameraMotionModel) { }
}

export class ResetCamera {
  static readonly type = '[Engine Camera] Reset Camera';
  constructor() { }
}

export class ZoomCamera {
  static readonly type = '[Engine Camera] Zoom Camera';
  constructor(public value: number) { }
}

export class ZoomCameraStatic {
  static readonly type = '[Engine Camera] Zoom Camera Static';
  constructor(public value: number) { }
}

export class PanCameraX {
  static readonly type = '[Engine Camera] Pan Camera X';
  constructor(public value: number) { }
}

export class PanCameraY {
  static readonly type = '[Engine Camera] Pan Camera Y';
  constructor(public value: number) { }
}

export class PanCameraStatic {
  static readonly type = '[Engine Camera] Pan Camera Static';
  constructor(public x: number, public y: number, public z: number) {}
}

export class RotateCameraX {
  static readonly type = '[Engine Camera] Rotate Camera X';
  constructor(public value: number) { }
}

export class RotateCameraY {
  static readonly type = '[Engine Camera] Rotate Camera Y';
  constructor(public value: number) { }
}

export class RotateCameraStatic {
  static readonly type = '[Engine Camera] Rotate Camera Static';
  constructor(public x: number, public y: number) { }
}

export class SetCameraMode {
  static readonly type = '[Engine Camera] Set Camera Mode';
  constructor(public mode: 'pan' | 'rotate') { }
}

export class SetZoomed {
  static readonly type = '[Engine Camera] Set Zoomed';
  constructor(public zoomed: boolean) { }
}

export class LockCamera {
  static readonly type = '[Engine Camera] Lock camera';
  constructor(public lock: boolean) { }
}
export class SetCameraFlyTo {
  static readonly type = '[Engine Camera] Set Camera Fly To';
  constructor(public camera: CameraModel) { }
}

export class ApplyCameraPatch {
  static readonly type = '[Engine Camera] Patch Camera State';
  constructor(public patches: Patch[]) { }
}
